import { AdminIntroductions } from '@platform/client';
import { useParams } from 'wouter';
import { AdminDetailPage } from '../../AdminDetailPage';
import { DetailsTabContent } from './DetailsTabContent';

export const IntroductionDetail = () => {
  const { introductionId } = useParams<{ introductionId: string }>();
  const {
    data: introData,
    isLoading,
    isSuccess,
  } = AdminIntroductions.useGetIntroductionById(parseInt(introductionId));

  return (
    <>
      <AdminDetailPage
        title={
          introData?.introduction?.id ?
            `Introduction #${introData.introduction.id}`
          : 'Introduction Details'
        }
        isLoading={isLoading}
        isSuccess={isSuccess}
        tabs={[
          {
            id: 'Details',
            content: (
              <DetailsTabContent
                introData={introData?.introduction}
                planData={introData?.projectPlan}
              />
            ),
          },
        ]}
        pageActions={[
          {
            text: 'Edit',
            href: `/${introductionId}/edit`,
            type: 'link',
          },
        ]}
      />
    </>
  );
};
